import React from 'react';
import TopicsPageLayout from '../components/TopicsPageLayout.jsx';
import TopicsRouter from '../components/TopicsRouter.jsx';
import topicData from './medicine.json';

const Medicine = () => {
  return (
    <div className="topic-page-container">
        <TopicsPageLayout
            
            description="Medical vocabulary, healthcare systems, and health discussions. B2/C1 level grammar, reading, and vocabulary exercises."
            level="B2"
            title="Medicine"
            image="/Images/sense1.webp"
            seoTitle="Free English Lesson Plans: Medicine"
            seoDescription="Medical vocabulary, healthcare systems, and health discussions. B2/C1 level grammar, reading, and vocabulary exercises."
        >
            {topicData.map((section, index) => (
                <div key={index} className="lesson-section-wrapper">
                    <TopicsRouter sectionData={section} />
                </div>
            ))}
        </TopicsPageLayout>
    </div>
  );
};

export default Medicine;


